import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Suspense as _Suspense, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "card"
}
const _hoisted_2 = {
  key: 0,
  class: "p-fluid"
}
const _hoisted_3 = { class: "p-fluid" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-fluid" }
const _hoisted_6 = { class: "field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_Header = _resolveComponent("Header")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _component_Subid = _resolveComponent("Subid")!
  const _component_PrimeVueColumn = _resolveComponent("PrimeVueColumn")!
  const _component_PrimeVueDataTable = _resolveComponent("PrimeVueDataTable")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _component_FieldBidCPC = _resolveComponent("FieldBidCPC")!
  const _component_PrimeVueCalendar = _resolveComponent("PrimeVueCalendar")!
  const _component_FiltersSidebar = _resolveComponent("FiltersSidebar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PrimeVueMessage, {
      severity: "info",
      closable: false
    }, {
      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
        _createElementVNode("div", { class: "mx-3" }, "Right now, we only support the HilltopAds feed provider 🤷‍♂️", -1)
      ]))]),
      _: 1
    }),
    _createVNode(_component_Header, {
      class: "mb-3",
      title: "Discrepancies 🔍",
      "show-refresh-button": "",
      "refresh-button-loading": _ctx.discrepanciesLoading,
      "refresh-button-handler": _ctx.fetchDiscrepanciesWrapper,
      "show-filters-button": "",
      "show-filters": _ctx.showFilters,
      "onUpdate:showFilters": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showFilters) = $event))
    }, null, 8, ["refresh-button-loading", "refresh-button-handler", "show-filters"]),
    (_ctx.discrepanciesLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          }),
          _createVNode(_component_PrimeVueSkeleton, {
            class: "mb-2",
            height: "20px"
          })
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_PrimeVueDataTable, {
            value: _ctx.discrepancies.data,
            "responsive-layout": "scroll",
            "striped-rows": "",
            "sort-field": "revenue_percent",
            "sort-order": -1,
            "row-class": _ctx.getStatisticRowClass
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PrimeVueColumn, {
                header: "Subid",
                field: "subid_uuid"
              }, {
                body: _withCtx(({ data }) => [
                  (_openBlock(), _createBlock(_Suspense, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Subid, {
                        "subid-uuid": data.subid_uuid,
                        subid: data.subid,
                        "onUpdate:subid": ($event: any) => ((data.subid) = $event),
                        "quality-presets": _ctx.qualityPresets,
                        "quality-presets-fetched": _ctx.qualityPresetsFetched
                      }, null, 8, ["subid-uuid", "subid", "onUpdate:subid", "quality-presets", "quality-presets-fetched"])
                    ]),
                    fallback: _withCtx(() => [
                      _createVNode(_component_PrimeVueSkeleton, { height: "50px" })
                    ]),
                    _: 2
                  }, 1024))
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeVueColumn, {
                header: "Est. revenue",
                field: "revenue_est",
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.$n(data.revenue_est, 'payout')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeVueColumn, {
                header: "Revenue",
                field: "revenue",
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.$n(data.revenue, 'payout')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_PrimeVueColumn, {
                header: "Revenue %",
                field: "revenue_percent",
                sortable: ""
              }, {
                body: _withCtx(({ data }) => [
                  _createTextVNode(_toDisplayString(_ctx.$n(data.revenue_percent, 'percent')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "row-class"])
        ])),
    _createVNode(_component_FiltersSidebar, {
      visible: _ctx.showFilters,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showFilters) = $event)),
      "apply-button-handler": _ctx.fetchDiscrepanciesWrapper,
      "apply-button-loading": _ctx.discrepanciesLoading
    }, {
      default: _withCtx(() => [
        (_ctx.user.isSuperAdmin())
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.filters.project_id,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.project_id) = $event)),
                  _ctx.onProjectChange
                ],
                modelModifiers: { number: true },
                label: _ctx.$t('project'),
                "show-clear": true,
                loading: _ctx.projectsLoading,
                options: _ctx.projects.data,
                "option-value": "id",
                "option-label": "name",
                "option-label-translate": false
              }, null, 8, ["modelValue", "label", "loading", "options", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_FieldDropdown, {
            modelValue: _ctx.filters.feed_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.feed_id) = $event)),
            modelModifiers: { number: true },
            label: _ctx.$t('feed'),
            filter: true,
            "show-clear": true,
            loading: _ctx.feedsLoading,
            options: _ctx.feeds.data,
            "option-value": "id",
            "option-label": "compiled_name",
            "option-label-translate": false,
            "multiple-sort-by-value": true
          }, null, 8, ["modelValue", "label", "loading", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FieldBidCPC, {
            modelValue: _ctx.filters.min_revenue_est,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.min_revenue_est) = $event)),
            modelModifiers: { number: true },
            name: "min_revenue_est",
            label: "Min est. $"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[7] || (_cache[7] = _createElementVNode("label", null, "Period", -1)),
            _createVNode(_component_PrimeVueCalendar, {
              modelValue: _ctx.filtersDatePeriod,
              "onUpdate:modelValue": [
                _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filtersDatePeriod) = $event)),
                _ctx.onFiltersDatePeriodChange
              ],
              "selection-mode": "range",
              "manual-input": false,
              "show-button-bar": ""
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "apply-button-handler", "apply-button-loading"])
  ], 64))
}